export default __webpack_public_path__ + "static/media/TVyNovelas.49e761e0.jpg";